import baselinePendingActions from './baseline-pending-actions.svg'
import chartProportion from './chart-proportion.svg'
import clockPause from './clock-pause.svg'
import fire from './fire.svg'
import skillLevelIntermediate from './skill-level-intermediate.svg'

const recipeIcons = [baselinePendingActions, chartProportion, clockPause, fire, skillLevelIntermediate]

export default recipeIcons
